import { Http } from '@/core';
import qs from 'qs';
import {
  GetBaselineArgs,
  BaselineExistingItemDto,
  BaselinePersonalizationItemDto,
  BaselineSpecialRequestDto,
  GetBaselinePersonalizationItemArgs,
  GetBaselineSpecialRequestArgs,
} from './baselineTypes';

class BaselineHttp extends Http {
  public async getPersonalizationItems(
    args: GetBaselinePersonalizationItemArgs,
  ) {
    const { homeId, ...pArgs } = args;
    const query = qs.stringify(pArgs);

    const response = await this._axios.get<BaselinePersonalizationItemDto[]>(
      `/api/home/${homeId}/baseline/personalization-items?${query}`,
    );
    return response.data;
  }

  public async getSpecialRequests(args: GetBaselineSpecialRequestArgs) {
    const { homeId, ...pArgs } = args;
    const query = qs.stringify(pArgs);

    const response = await this._axios.get<BaselineSpecialRequestDto[]>(
      `/api/home/${homeId}/baseline/special-requests?${query}`,
    );
    return response.data;
  }

  public async getExistingItems(args: GetBaselineArgs) {
    const { homeId, ...pArgs } = args;
    const query = qs.stringify(pArgs);

    const response = await this._axios.get<BaselineExistingItemDto[]>(
      `/api/home/${homeId}/baseline/existing-items?${query}`,
    );
    return response.data;
  }
}

export const baselineHttp = new BaselineHttp();
